import { IconProps } from './icons-props';

function CrownIcon({ className, width = 22, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 22 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M1 13.29V3.71002C1 2.38002 1.77 2.06002 2.71 3.00002L5.3 5.59002C5.69 5.98002 6.33 5.98002 6.71 5.59002L10.29 2.00002C10.68 1.61002 11.32 1.61002 11.7 2.00002L15.29 5.59002C15.68 5.98002 16.32 5.98002 16.7 5.59002L19.29 3.00002C20.23 2.06002 21 2.38002 21 3.71002V13.3C21 16.3 19 18.3 16 18.3H6C3.24 18.29 1 16.05 1 13.29Z'
                fill='currentColor'
                stroke='currentColor'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
}

export default CrownIcon;

